<template>
  <li>
    <Modal
      :width="400"
      :value="inputModalOpen"
      ctaText="Add"
      actions-border
      overlayColor="#ffffff"
      overlayOpacity="0.83"
      @cancel="inputModalOpen = false"
      title="Add input question"
      @confirm="confirmInputQuestionModal">
      <template #default>
        <label class="default-question__label"> {{ $t("shortcodes.live_chat_auto.default_question") }} </label>
        <v-select
          v-model="inputQuestionValue"
          class="input-question__select"
          hide-details
          :items="inputQuestionOptions"
          :menu-props="{
            offsetOverflow: true,
            offsetY: true,
          }"
          placeholder="Input question">
        </v-select>
      </template>
    </Modal>

    <span class="tree-item" :class="{ 'tree-item--error': node._telHrefError }">
      <div class="sender-indicator">
        <div class="d-flex align-center">
          <v-tooltip v-if="node.messageType === 'decision'" top>
            <template #activator="{ on }">
              <div v-on="on">
                <v-icon class="sender-indicator--forum mr-2">mdi-eye-off-outline</v-icon>
              </div>
            </template>
            <span>{{ $t("shortcodes.live_chat_auto.decision_tooltip") }}</span>
          </v-tooltip>
          <v-icon v-else class="sender-indicator--bot mr-2">mdi-robot</v-icon>

          <span v-if="node.messageType === 'message'">
            {{ $t("shortcodes.live_chat_auto.message") }}
          </span>
          <span v-if="node.messageType === 'inputQuestion'">{{ $t("shortcodes.live_chat_auto.input_question") }}</span>
          <span v-if="node.messageType === 'zipInputQuestion'">{{ $t("shortcodes.live_chat_auto.zip_input_question") }}</span>
          <span v-if="node.messageType === 'decision'">{{ $t("shortcodes.live_chat_auto.decision") }}</span>
          <span v-if="node.messageType === 'action'">
            {{ $t("shortcodes.live_chat_auto.action") }}
          </span>
          <span v-if="node.messageType === 'actionItem'">
            {{ $t("shortcodes.live_chat_auto.action_item") }}
            <span v-if="node.messageType === 'actionItem'">{{ index + 1 }}</span>
          </span>
        </div>
      </div>
      <div v-if="parent" @click="removeNode" class="remove-node">
        <v-icon>mdi-trash-can-outline</v-icon>
      </div>
      <div
        v-if="node.messageType === 'actionItem' || node.messageType === 'decision'"
        @click="copyNode"
        class="copy-node">
        <v-icon>mdi-dock-window</v-icon>
      </div>
      <div>
        <div class="message-item">
          <LiveChatMp4Message ref="message" v-if="node.messageType === 'message'" :node.sync="node"></LiveChatMp4Message>
          <LiveChatMp4InputQuestion
            ref="inputQuestion"
            v-if="node.messageType === 'inputQuestion'"
            :node.sync="node"></LiveChatMp4InputQuestion>
          <LiveChatMp4ZipInput
            ref="zipInput"
            v-if="node.messageType === 'zipInputQuestion'"
            :node.sync="node"></LiveChatMp4ZipInput>
          <LiveChatMp4Action v-if="node.messageType === 'action'" :node.sync="node"></LiveChatMp4Action>
          <LiveChatMp4ActionItem v-if="node.messageType === 'actionItem'" :node.sync="node"></LiveChatMp4ActionItem>
          <LiveChatMp4Decision
            v-if="node.messageType === 'decision' && (!parent || parent.messageType !== 'zipInputQuestion')"
            :node.sync="node"></LiveChatMp4Decision>
          <LiveChatMp4ZipDecision
            v-if="node.messageType === 'decision' && parent && parent.messageType === 'zipInputQuestion'"
            :node.sync="node"></LiveChatMp4ZipDecision>
          <div v-if="node.messageType === 'defaultQuestion'" class="text-caption text--secondary">Default question (no longer supported)</div>
        </div>
        <v-btn class="mr-2" v-if="displayAddMessageBtn" @click="addMessage">{{
          $t("shortcodes.live_chat_auto.add_message")
        }}</v-btn>
        <v-btn v-if="displayAddActionBtn" @click="addAction">{{ $t("shortcodes.live_chat_auto.add_action") }}</v-btn>
        <v-btn v-if="displayAddInputQuestion" @click="openInputQuestionModal">{{
          $t("shortcodes.live_chat_auto.add_input_question")
        }}</v-btn>
        <v-btn v-if="displayAddDecision" @click="addDecision">{{
          $t("shortcodes.live_chat_auto.add_decision")
        }}</v-btn>
        <v-btn v-if="displayAddActionItem" @click="addActionItem">{{
          $t("shortcodes.live_chat_auto.add_action_item")
        }}</v-btn>
      </div>
    </span>
    <ul v-if="node.children && node.children.length">
      <LiveChatMp4TreeNode
        v-for="(child, index) in node.children"
        ref="children"
        :index="index"
        :key="index"
        :node="child"
        :parent="node"
        @openModal="$emit('openModal', $event)"></LiveChatMp4TreeNode>
    </ul>
  </li>
</template>

<script>
  import cloneDeep from "lodash/cloneDeep";
  import LiveChatMp4Message from "./LiveChatMp4Message.vue";
  import LiveChatMp4InputQuestion from "./LiveChatMp4InputQuestion.vue";
  import LiveChatMp4ZipInput from "./LiveChatMp4ZipInput.vue";
  import LiveChatMp4Decision from "./LiveChatMp4Decision.vue";
  import LiveChatMp4ZipDecision from "./LiveChatMp4ZipDecision.vue";
  import LiveChatMp4Action from "./LiveChatMp4Action.vue";
  import LiveChatMp4ActionItem from "./LiveChatMp4ActionItem.vue";
  import {
    MESSAGE_MP4,
    ACTION,
    ACTION_ITEM,
    INPUT_QUESTION,
    ZIP_INPUT_QUESTION,
    DECISION,
    INPUT_QUESTION_DISPLAY_TYPES,
    ZIP_INPUT_DISPLAY_TYPES,
    LIVE_CHAT_MP4_ACTION_DEFAULTS,
    LIVE_CHAT_MP4_ACTION_ITEM_DEFAULTS,
  } from "./constant";
  import Modal from "@/components/custom/Modal.vue";

  export default {
    name: "LiveChatMp4TreeNode",
    components: {
      LiveChatMp4Message,
      LiveChatMp4InputQuestion,
      LiveChatMp4ZipInput,
      LiveChatMp4Decision,
      LiveChatMp4ZipDecision,
      LiveChatMp4Action,
      LiveChatMp4ActionItem,
      Modal,
    },
    props: {
      node: {
        type: Object,
        required: true,
      },
      parent: {
        type: Object,
        default: null,
      },
      index: {
        type: Number,
        default: 0,
      },
    },
    emits: ["openModal"],
    data() {
      return {
        inputModalOpen: false,
        inputQuestionValue: "enter_age",
        inputQuestionOptions: [
          { text: "Enter your age", value: "enter_age" },
          { text: "Enter your birth year", value: "enter_birth_year" },
          { text: "Enter your birth year (Underscore)", value: "enter_birth_year_underscore" },
          { text: "Enter ZIP code", value: "enter_zip" },
        ],
      };
    },
    computed: {
      displayAddMessageBtn() {
        if (this.node.messageType === "action") return false;
        if (this.node.messageType === "inputQuestion") return false;
        if (this.node.messageType === "zipInputQuestion") return false;
        return true;
      },
      displayAddActionBtn() {
        if (this.node.children?.some(childNode => childNode.messageType === "action")) return false;
        if (this.node.children?.some(childNode => childNode.messageType === "inputQuestion")) return false;
        if (this.node.children?.some(childNode => childNode.messageType === "zipInputQuestion")) return false;
        if (this.node.messageType === "actionItem") return false;
        if (this.node.messageType === "action") return false;
        if (this.node.messageType === "inputQuestion") return false;
        if (this.node.messageType === "zipInputQuestion") return false;
        return true;
      },
      displayAddInputQuestion() {
        if (this.node.messageType === "action") return false;
        if (this.node.messageType === "inputQuestion") return false;
        if (this.node.messageType === "zipInputQuestion") return false;
        if (
          this.node.children?.some(
            childNode =>
              childNode.messageType === "inputQuestion" ||
              childNode.messageType === "zipInputQuestion" ||
              childNode.messageType === "action",
          )
        )
          return false;
        return true;
      },
      displayAddDecision() {
        if (this.node.messageType === "inputQuestion") return true;
        if (this.node.messageType === "zipInputQuestion") {
          return !this.node.children?.some(childNode => childNode.messageType === "decision");
        }
        return false;
      },
      displayAddActionItem() {
        return this.node.messageType === "action";
      },
    },
    watch: {
      "node.content"() {
        if (this.node._telHrefError) this.$delete(this.node, "_telHrefError");
      },
      "node.text"() {
        if (this.node._telHrefError) this.$delete(this.node, "_telHrefError");
      },
      "node.value"() {
        if (this.node._telHrefError) this.$delete(this.node, "_telHrefError");
      },
    },
    methods: {
      copyNode() {
        const copiedNode = cloneDeep(this.node);
        let children = this.parent.children;
        this.parent.children = [];
        this.$nextTick(() => {
          children.splice(this.index + 1, 0, copiedNode);
          this.parent.children = children;
        });
      },
      removeNode() {
        if (this.node.messageType === "actionItem" && this.node.children.length > 0) {
          this.$emit("openModal", {
            title: "Warning!",
            subtitle:
              "If an action item is deleted, all messages and other action items coming after it will also be deleted.",
            ctaText: "Delete",
            delete: true,
            index: this.index,
            parent: this.parent,
          });
        } else if (this.node.messageType === "action" && this.node.children.length > 0) {
          this.$emit("openModal", {
            title: "Cannot delete!",
            subtitle:
              '"Action" cannot be deleted, because it still has action items that belong to it. Action items will not function without "Action".',
            ctaText: "Ok, understood",
            delete: false,
            cancelHidden: true,
          });
        } else if (this.node.messageType === "inputQuestion" && this.node.children.length > 0) {
          this.$emit("openModal", {
            title: "Cannot delete!",
            subtitle:
              '"Input question" cannot be deleted, because it still has decisions that belong to it. Decisions will not function without "Input question".',
            ctaText: "Ok, understood",
            delete: false,
            cancelHidden: true,
          });
        } else if (this.node.messageType === "zipInputQuestion" && this.node.children.length > 0) {
          this.$emit("openModal", {
            title: "Cannot delete!",
            subtitle:
              '"ZIP input question" cannot be deleted, because it still has decisions that belong to it. Decisions will not function without "ZIP input question".',
            ctaText: "Ok, understood",
            delete: false,
            cancelHidden: true,
          });
        } else if (this.node.messageType === "decision" && this.node.children.length > 0) {
          this.$emit("openModal", {
            title: "Warning!",
            subtitle:
              "If a decision is deleted, all messages and other decision coming after it will also be deleted.",
            ctaText: "Delete",
            delete: true,
            index: this.index,
            parent: this.parent,
          });
        } else if (this.node.children.length > 0) {
          const children = this.node.children;
          this.updateTreeContent(children, this);
          this.parent.children = children;
        } else {
          this.parent.children.splice(this.parent.children.indexOf(this.node), 1);
        }
      },
      openInputQuestionModal() {
        this.inputModalOpen = true;
      },
      confirmInputQuestionModal() {
        this.inputModalOpen = false;
        this.addInputQuestion();
      },
      addInputQuestion() {
        if (this.inputQuestionValue === "enter_zip") {
          this.addZipInputQuestion();
          return;
        }
        const inputQuestion = cloneDeep(INPUT_QUESTION);
        inputQuestion.inputQuestionType = this.inputQuestionValue;
        inputQuestion.inputQuestionDisplayType =
          this.inputQuestionValue === "enter_age"
            ? INPUT_QUESTION_DISPLAY_TYPES.find(type => type.value === "age").value
            : INPUT_QUESTION_DISPLAY_TYPES.find(type => type.value === "years").value;
        this.node.children.push(inputQuestion);
      },
      addZipInputQuestion() {
        const zipInputQuestion = cloneDeep(ZIP_INPUT_QUESTION);
        zipInputQuestion.zipInputDisplayType = ZIP_INPUT_DISPLAY_TYPES.find(type => type.value === "empty").value;
        this.node.children.push(zipInputQuestion);
      },
      addDecision() {
        const decision = cloneDeep(DECISION);
        this.node.children.push(decision);
      },
      addAction() {
        const action = cloneDeep({ ...ACTION, ...LIVE_CHAT_MP4_ACTION_DEFAULTS });
        if (this.node.children.length > 0) {
          const actionItem = cloneDeep({ ...ACTION_ITEM, ...LIVE_CHAT_MP4_ACTION_ITEM_DEFAULTS });
          const children = this.node.children;
          action.children = [actionItem];
          actionItem.children = children;
          this.node.children = [action];
        } else {
          this.node.children.push(action);
        }
      },
      addActionItem() {
        const actionItem = cloneDeep({ ...ACTION_ITEM, ...LIVE_CHAT_MP4_ACTION_ITEM_DEFAULTS });
        this.node.children.push(actionItem);
      },
      addMessage() {
        const message = cloneDeep(MESSAGE_MP4);
        if (this.node.children.length > 0) {
          const children = this.node.children;
          message.children = children;
          this.updateTreeContent([message], this.$refs.children[0]);
          this.node.children = [message];
        } else {
          this.node.children.push(message);
        }
      },
      updateTreeContent(children, ref) {
        let index = ref?.index != null ? ref.index : 0;
        if (children[index].messageType === "message" && ref && ref.$refs.message) {
          ref.$refs.message.updateContent(children[index].content);
          if (children[index].children?.length > 0 && ref.$refs.children) {
            this.updateTreeContent(children[index].children, ref.$refs.children[index]);
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";
  .sender-indicator {
    position: absolute;
    top: 10px;
    left: 10px;
    &--bot {
      color: orange !important;
    }

    &--forum {
      color: #2377f8 !important;
    }
  }

  .tree-item {
    padding: 45px 10px 10px 10px;
    border-radius: 5px;
    &--error {
      border: 3px dashed get-color("error") !important;
    }
  }

  .remove-node {
    padding: 5px;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    z-index: 2;
  }

  .copy-node {
    padding: 5px 35px 5px 5px;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    z-index: 1;
  }

  .default-question {
    &__label {
      color: get-color("subtitle");
      @include text-caption-bold();
    }

    &__select {
      padding-top: 0;
    }

    &__border {
      border-top: 1px solid get-color("border");
    }
  }

  .font-semibold {
    font-weight: 600;
  }
</style>
